<template>
      <div>
        <b-icon v-if="data.state == 0" icon="exclamation-triangle" variant="warning" animation="throb" font-scale="8" />
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <p v-if="data.state == 0"> {{$t('signal.actions.setState')}} </p>
   </div>
</template>

<script>
    import jwt_decode from "jwt-decode";

    export default {
        name: "SetStateAccount",
        //
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function,
            getSignal: Function
        },
        watch: {
            save: async function(data){
                if(data){
                    let params =  {
                        "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                        "event" : "outProcessedSignal",
                        "signal_id": this.data.signal.id
                    }
                    this.$socket.send(JSON.stringify(params))
                    this.getSignal()
                    this.modalEvent(false)
                }
                this.saveState(false)
                this.modalEvent(false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/modals/SetState.vue